<template>
  <div class="toolbar-search">
    <div class="search-input">
      <div class="filter" @click="dropdown = !dropdown">
        <input class="btn-filter" type="button" size=8 v-model="filterTitle">
      </div>
      <input class="keyword" type="text" v-model="keywords" :placeholder="$t('base.enterkeywords')">
      <div class="dropdown" v-if="dropdown">
        <div
          v-for="(item, index) in filterList"
          :key="index"
          class="search-menu-item"
          @click="setFilter(item.name)"
        >{{item.title}}</div>
      </div>
    </div>
    <div class="search-submit" @click="submit">{{ $t("base.search") }}</div>
    <GisBtn v-if="gis" :gisurl="gisurl" class="search-gis"></GisBtn>
  </div>
</template>

<script>
import GisBtn from "@/components/GisBtn.vue";
export default {
  props: {
    gis: Boolean,
    gisurl: String,
    filterList: Array
  },
  components: {
    GisBtn
  },
  data() {
    return {
      dropdown: false,
      filter: "",
      keywords: ""
    };
  },
  computed: {
    filterTitle() {
      for (let value of this.filterList) {
        if (value.name === this.filter) {
          return value.title;
        }
      }
    }
  },
  mounted() {
    this.filter = this.filterList[0].name;
  },
  methods: {
    setFilter(filter) {
      this.filter = filter;
      this.dropdown = false;
    },
    submit() {
      let data = {};

      if (this.keywords) {
        data[this.filter] = this.keywords;
        this.$emit("search", data);
      } else {
        this.$emit("offsearch");
      }
    }
  }
};
</script>

<style lang="scss">
@import "../assets/base";
.toolbar-search {
  position: relative;
  display: inline-flex;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  line-height: 1;

  input {
    padding: 0;
    margin: 0;
    font-size: 0.75rem;
  }

  .search-input {
    position: relative;
    display: flex;
    height: 2rem;
    margin-right: 1.5rem;
    margin-left: 5px;
    background-image: url("~@/assets/img/search-input.png");
    background-size: auto 100%;
    white-space: nowrap;

    .filter {
      padding: 0.4rem 0.5rem 0.5rem;

      &::after {
        content: "";
        display: inline-block;
        margin-left: 0.25rem;
        width: 0.5rem;
        height: 0.4rem;
        background-image: url("~@/assets/img/arrow-down.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }

    .keyword {
      width: 6rem;
      height: 1rem;
      margin-top: 0.5rem;
      padding-left: 0.5rem;
      padding-right: 0.25rem;
      line-height: 1rem;
      border-left: 1px solid rgba(0, 0, 0, 0.5);
    }

    &::before,
    &::after {
      content: "";
      position: absolute;
      display: block;
      width: 10px;
      height: 100%;
      background-size: auto 100%;
      background-repeat: no-repeat;
    }

    &::before {
      left: -10px;
      background-image: url("~@/assets/img/search-input-left.png");
      background-position-x: right;
    }

    &::after {
      right: -10px;
      background-image: url("~@/assets/img/search-input-right.png");
      background-position-x: left;
    }
  }

  .dropdown {
    position: absolute;
    z-index: 50;
    top: 2rem;
    left: -5px;
    padding: 0.5rem 0;
    background-color: #e9ddbf;
    box-shadow: 0 5px 5px rgba(0, 0, 0, 0.4);

    .search-menu-item {
      min-width: 5rem;
      padding: 0.5rem 1rem;

      &:active,
      &:focus {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
  }

  .search-submit {
    position: relative;
    display: block;
    height: 2rem;
    padding: 0 0.75rem;
    color: $text-dark;
    line-height: 2rem;
    background-image: url("~@/assets/img/btn-search.png");
    background-size: auto 100%;

    &::before,
    &::after {
      content: "";
      position: absolute;
      display: block;
      width: 10px;
      height: 100%;
      background-size: auto 100%;
      background-repeat: no-repeat;
    }

    &::before {
      left: -10px;
      background-image: url("~@/assets/img/btn-search-left.png");
      background-position-x: right;
    }

    &::after {
      top: 0;
      right: -10px;
      background-image: url("~@/assets/img/btn-search-right.png");
      background-position-x: left;
    }
  }

  .search-gis {
    position: relative;
    left: 1rem;
    top: -0.25rem;
  }
}
</style>
